import { FC } from 'react'
import IconBack from 'assets/arrow-go-back-line.svg?react'
import cn from 'classnames'
import { Button } from 'components/extend/Button'
import { PlaceholderCell } from 'components/extend/PlaceholderCell'
import { getFullNameFromFio } from 'helpers/string'
import { getContactFullPhone } from 'modules/contact/helpers'
import { OrderItemClient } from 'schema'

import { OrderClientBlockProps } from './types'

import s from './styles.module.less'

const OrderClientBlock: FC<OrderClientBlockProps> = (props) => {
  const {
    isWithoutContact = false,
    title,
    orderClientType,
    orderClientCompany,
    orderClientContact,
    isLoading,
    isShowSelect,
    handleShowSelect
  } = props

  // TODO заменить на проверку выше
  if (!orderClientCompany && !orderClientContact) {
    return null
  }

  return (
    <div data-test-id="order--client--block">
      {!!title && <h2 className={s.outerTitle}>{title}</h2>}
      {orderClientType === OrderItemClient.type.LEGAL && orderClientCompany ? (
        <div className={cn(s.partnerBlock, { [s.partnerBlock__select]: isShowSelect })}>
          {!isLoading ? (
            <div className={cn(s.innerTitle, 'break-all')}>{orderClientCompany?.name}</div>
          ) : (
            <PlaceholderCell className={cn(s.skeletonRow, s.skeletonRow_title)} height={20} />
          )}
          <div className={s.innerBody}>
            <div className={s.outerRow}>
              <div className={s.innerRow}>
                {!isLoading ? (
                  <>
                    <div className={s.innerLabel}>ИНН</div>
                    <div className={s.innerContent}>{orderClientCompany?.inn || '—'}</div>
                  </>
                ) : (
                  <PlaceholderCell className={s.skeletonRow} height={20} />
                )}
              </div>
              <div className={s.innerRow}>
                {!isLoading ? (
                  <>
                    <div className={s.innerLabel}>КПП</div>
                    <div className={s.innerContent}>{orderClientCompany?.kpp || '—'}</div>
                  </>
                ) : (
                  <PlaceholderCell className={s.skeletonRow} height={20} />
                )}
              </div>
            </div>
            {!!orderClientContact && !isWithoutContact && <div className={s.divider} />}
            {!isWithoutContact && (
              <div className={s.outerRow}>
                {orderClientContact && (
                  <div className={s.innerRow}>
                    {!isLoading ? (
                      <>
                        <div className={s.innerLabel}>Контактное лицо</div>
                        <div className={cn(s.innerContent, 'break-all')}>
                          {getFullNameFromFio({
                            firstname: orderClientContact.firstname,
                            lastname: orderClientContact.lastname,
                            secondname: orderClientContact.secondname
                          }) || <span className="text-on-surface-variant/[10]">Контакт без имени</span>}
                        </div>
                      </>
                    ) : (
                      <PlaceholderCell className={s.skeletonRow} height={20} />
                    )}
                  </div>
                )}
                {orderClientContact ? (
                  <div className={s.innerRow}>
                    {!isLoading ? (
                      <>
                        <div className={s.innerLabel}>Телефон</div>
                        {/* @ts-ignore */}
                        <div className={s.innerContent}>{getContactFullPhone(orderClientContact)}</div>
                      </>
                    ) : (
                      <PlaceholderCell className={s.skeletonRow} height={20} />
                    )}
                  </div>
                ) : (
                  ''
                )}
              </div>
            )}
          </div>
          {isShowSelect && (
            <Button className={cn(s.select, s.selectBtn)} onClick={handleShowSelect} size="lg">
              <IconBack size="xs" />
              Заменить
            </Button>
          )}
        </div>
      ) : (
        <div className={cn(s.partnerBlock, { [s.partnerBlock__select]: isShowSelect })}>
          {!isLoading ? (
            <div className={cn(s.innerTitle, 'break-all')}>
              {getFullNameFromFio({
                firstname: orderClientContact?.firstname || '',
                lastname: orderClientContact?.lastname || '',
                secondname: orderClientContact?.secondname
              }) || <span className="text-on-surface-variant/[10]">Контакт без имени</span>}
            </div>
          ) : (
            <PlaceholderCell className={cn(s.skeletonRow, s.skeletonRow_title)} height={20} />
          )}
          <div className={s.innerBody}>
            <div className={s.outerRow}>
              <div className={s.innerRow}>
                {!isLoading ? (
                  <>
                    {/* @ts-ignore */}
                    <div className={s.innerContent}>{getContactFullPhone(orderClientContact)}</div>
                  </>
                ) : (
                  <PlaceholderCell className={s.skeletonRow} height={20} />
                )}
              </div>
            </div>
          </div>
          {isShowSelect && (
            <Button className={cn(s.select, s.selectBtn)} onClick={handleShowSelect} size="lg">
              <IconBack size="xs" />
              Заменить
            </Button>
          )}
        </div>
      )}
    </div>
  )
}

export default OrderClientBlock
